var _rect, _rect2, _g, _g2, _g3, _g4, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 397,
    height: 232,
    viewBox: "0 0 397 232",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46.4,
    y: 17.4,
    width: 319.2,
    height: 189.2,
    rx: 25.2,
    fill: "#FDFDFD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46.4,
    y: 17.4,
    width: 319.2,
    height: 189.2,
    rx: 25.2,
    stroke: "#E5E5E5",
    strokeWidth: 0.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bd_1755_30647)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247,
    y: 16,
    width: 130,
    height: 48,
    rx: 8,
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.96 36L257.84 29H259.52L262.36 36H260.79L260.08 34.16H257.19L256.47 36H254.96ZM257.64 33H259.64L258.65 30.42L257.64 33ZM262.62 35.38L263.3 34.47C263.91 34.87 264.44 35.06 264.99 35.06C265.6 35.06 266 34.84 266 34.51C266 34.24 265.8 34.09 265.35 34.02L264.35 33.87C263.32 33.71 262.77 33.2 262.77 32.36C262.77 31.35 263.61 30.71 264.94 30.71C265.7 30.71 266.43 30.93 267.08 31.36L266.42 32.24C265.85 31.9 265.34 31.74 264.81 31.74C264.31 31.74 263.99 31.94 263.99 32.25C263.99 32.53 264.19 32.67 264.7 32.74L265.7 32.89C266.72 33.04 267.29 33.57 267.29 34.38C267.29 35.36 266.32 36.1 265.01 36.1C264.06 36.1 263.21 35.85 262.62 35.38ZM267.551 35.38L268.231 34.47C268.841 34.87 269.371 35.06 269.921 35.06C270.531 35.06 270.931 34.84 270.931 34.51C270.931 34.24 270.731 34.09 270.281 34.02L269.281 33.87C268.251 33.71 267.701 33.2 267.701 32.36C267.701 31.35 268.541 30.71 269.871 30.71C270.631 30.71 271.361 30.93 272.011 31.36L271.351 32.24C270.781 31.9 270.271 31.74 269.741 31.74C269.241 31.74 268.921 31.94 268.921 32.25C268.921 32.53 269.121 32.67 269.631 32.74L270.631 32.89C271.651 33.04 272.221 33.57 272.221 34.38C272.221 35.36 271.251 36.1 269.941 36.1C268.991 36.1 268.141 35.85 267.551 35.38ZM277.622 35.35C276.982 35.87 276.342 36.1 275.512 36.1C273.932 36.1 272.712 34.92 272.712 33.4C272.712 31.89 273.882 30.7 275.392 30.7C276.872 30.7 277.972 31.9 277.972 33.5V33.86H274.092C274.282 34.51 274.852 34.95 275.572 34.95C276.032 34.95 276.442 34.8 276.722 34.53L277.622 35.35ZM275.362 31.83C274.732 31.83 274.252 32.24 274.082 32.88H276.632C276.462 32.26 275.962 31.83 275.362 31.83ZM279.326 34.53V31.94H278.256V30.79H279.326V29.46L280.696 29.15V30.79H282.176V31.94H280.696V34.25C280.696 34.74 280.886 34.92 281.416 34.92C281.676 34.92 281.876 34.89 282.146 34.8V35.92C281.856 36.01 281.386 36.08 281.086 36.08C279.926 36.08 279.326 35.55 279.326 34.53ZM255.63 52V45H259.14C260.52 45 261.49 45.91 261.49 47.2C261.49 48.45 260.5 49.36 259.14 49.36H257.08V52H255.63ZM258.98 46.25H257.08V48.16H258.98C259.61 48.16 260.02 47.78 260.02 47.21C260.02 46.63 259.61 46.25 258.98 46.25ZM262.347 52V46.79H263.717V47.36C264.047 46.91 264.527 46.67 265.107 46.67C265.377 46.68 265.537 46.71 265.677 46.79V47.99C265.477 47.9 265.227 47.85 264.977 47.85C264.447 47.85 263.977 48.12 263.717 48.63V52H262.347ZM267.099 46.17C266.669 46.17 266.319 45.82 266.319 45.39C266.319 44.96 266.669 44.61 267.099 44.61C267.529 44.61 267.879 44.96 267.879 45.39C267.879 45.82 267.529 46.17 267.099 46.17ZM267.789 46.79V52H266.419V46.79H267.789ZM271.41 50.9C271.88 50.9 272.28 50.72 272.65 50.32L273.47 51.17C272.93 51.76 272.15 52.1 271.35 52.1C269.81 52.1 268.62 50.92 268.62 49.4C268.62 47.88 269.81 46.69 271.35 46.69C272.18 46.69 272.97 47.03 273.51 47.62L272.67 48.51C272.29 48.09 271.87 47.88 271.38 47.88C270.59 47.88 269.98 48.54 269.98 49.4C269.98 50.26 270.6 50.9 271.41 50.9ZM278.657 51.35C278.017 51.87 277.377 52.1 276.547 52.1C274.967 52.1 273.747 50.92 273.747 49.4C273.747 47.89 274.917 46.7 276.427 46.7C277.907 46.7 279.007 47.9 279.007 49.5V49.86H275.127C275.317 50.51 275.887 50.95 276.607 50.95C277.067 50.95 277.477 50.8 277.757 50.53L278.657 51.35ZM276.397 47.83C275.767 47.83 275.287 48.24 275.117 48.88H277.667C277.497 48.26 276.997 47.83 276.397 47.83ZM279.455 51.38L280.135 50.47C280.745 50.87 281.275 51.06 281.825 51.06C282.435 51.06 282.835 50.84 282.835 50.51C282.835 50.24 282.635 50.09 282.185 50.02L281.185 49.87C280.155 49.71 279.605 49.2 279.605 48.36C279.605 47.35 280.445 46.71 281.775 46.71C282.535 46.71 283.265 46.93 283.915 47.36L283.255 48.24C282.685 47.9 282.175 47.74 281.645 47.74C281.145 47.74 280.825 47.94 280.825 48.25C280.825 48.53 281.025 48.67 281.535 48.74L282.535 48.89C283.555 49.04 284.125 49.57 284.125 50.38C284.125 51.36 283.155 52.1 281.845 52.1C280.895 52.1 280.045 51.85 279.455 51.38Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1755_30647)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 24,
    width: 64,
    height: 32,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.018 46.3871H303C301.895 46.3871 301 47.2825 301 48.3871V76C301 77.1046 301.895 78 303 78H371.952C373.056 78 373.952 77.1046 373.952 76V35.0237C373.952 34.4544 373.709 33.9121 373.285 33.5327L369.281 29.9525C368.231 29.0139 366.565 29.4253 366.074 30.7448L362.438 40.4956C361.757 42.3229 359.131 42.1944 358.631 40.3094L357.222 34.9919C356.805 33.4177 354.781 32.9755 353.745 34.2321L350.883 37.7046C350.277 38.4393 349.237 38.6451 348.397 38.1966L346.27 37.0604C345.257 36.5196 343.998 36.9406 343.514 37.9818L340.042 45.4538C339.33 46.9854 337.158 46.9998 336.426 45.4777L335.063 42.6446C334.343 41.1462 332.215 41.1302 331.472 42.6175L327.754 50.0594C327.065 51.4373 325.143 51.5525 324.295 50.2666L320.718 44.8425C320.196 44.0512 319.19 43.7349 318.309 44.0851L312.875 46.2456C312.639 46.3391 312.389 46.3871 312.136 46.3871H305.018Z",
    fill: "url(#paint0_linear_1755_30647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301 46.3871H310.603H312.337C312.597 46.3871 312.854 46.3364 313.095 46.238L318.3 44.107C319.184 43.7449 320.201 44.059 320.727 44.8568L324.295 50.2666C325.143 51.5525 327.065 51.4373 327.754 50.0594L331.472 42.6175C332.215 41.1302 334.343 41.1462 335.063 42.6446L336.426 45.4777C337.158 46.9998 339.33 46.9854 340.042 45.4538L343.514 37.9818C343.998 36.9406 345.257 36.5196 346.27 37.0604L348.397 38.1966C349.237 38.6451 350.277 38.4393 350.883 37.7046L353.745 34.2321C354.781 32.9755 356.805 33.4177 357.222 34.9919L358.631 40.3094C359.131 42.1944 361.757 42.3229 362.438 40.4956L366.074 30.7448C366.565 29.4253 368.231 29.0139 369.281 29.9525L373.952 34.129",
    stroke: "#0ECA82",
    strokeWidth: 0.6
  })), /*#__PURE__*/React.createElement("rect", {
    x: 305.4,
    y: 24.4,
    width: 63.2,
    height: 31.2,
    rx: 3.6,
    stroke: "#E5E5E5",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.4,
    y: 16.4,
    width: 129.2,
    height: 47.2,
    rx: 7.6,
    stroke: "#E5E5E5",
    strokeWidth: 0.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_bd_1755_30647)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247,
    y: 88,
    width: 130,
    height: 48,
    rx: 8,
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.18 102.28V101H261.34V102.28H258.99V108H257.54V102.28H255.18ZM261.634 108V102.79H263.004V103.36C263.334 102.91 263.814 102.67 264.394 102.67C264.664 102.68 264.824 102.71 264.964 102.79V103.99C264.764 103.9 264.514 103.85 264.264 103.85C263.734 103.85 263.264 104.12 263.004 104.63V108H261.634ZM267.21 108.09C266.09 108.09 265.31 107.44 265.31 106.49C265.31 105.5 266.11 104.91 267.45 104.91C267.88 104.91 268.31 104.98 268.72 105.11V104.74C268.72 104.14 268.35 103.83 267.62 103.83C267.18 103.83 266.69 103.97 266.03 104.26L265.53 103.25C266.35 102.87 267.1 102.69 267.85 102.69C269.26 102.69 270.07 103.39 270.07 104.62V108H268.72V107.64C268.28 107.95 267.81 108.09 267.21 108.09ZM266.62 106.46C266.62 106.86 266.99 107.11 267.57 107.11C268.02 107.11 268.4 107 268.72 106.78V106C268.38 105.87 268.02 105.81 267.62 105.81C266.99 105.81 266.62 106.06 266.62 106.46ZM274.996 108V107.57C274.576 107.9 274.066 108.07 273.516 108.07C272.036 108.07 270.866 106.89 270.866 105.39C270.866 103.89 272.046 102.72 273.556 102.72C274.066 102.72 274.566 102.86 274.976 103.13V101L276.346 100.7V108H274.996ZM272.216 105.39C272.216 106.24 272.876 106.9 273.736 106.9C274.246 106.9 274.666 106.72 274.976 106.4V104.37C274.676 104.06 274.226 103.88 273.736 103.88C272.866 103.88 272.216 104.53 272.216 105.39ZM282.095 107.35C281.455 107.87 280.815 108.1 279.985 108.1C278.405 108.1 277.185 106.92 277.185 105.4C277.185 103.89 278.355 102.7 279.865 102.7C281.345 102.7 282.445 103.9 282.445 105.5V105.86H278.565C278.755 106.51 279.325 106.95 280.045 106.95C280.505 106.95 280.915 106.8 281.195 106.53L282.095 107.35ZM279.835 103.83C279.205 103.83 278.725 104.24 278.555 104.88H281.105C280.935 104.26 280.435 103.83 279.835 103.83ZM283.284 108V102.79H284.654V103.36C284.984 102.91 285.464 102.67 286.044 102.67C286.314 102.68 286.474 102.71 286.614 102.79V103.99C286.414 103.9 286.164 103.85 285.914 103.85C285.384 103.85 284.914 104.12 284.654 104.63V108H283.284ZM255.63 124V117H259.14C260.52 117 261.49 117.91 261.49 119.2C261.49 120.45 260.5 121.36 259.14 121.36H257.08V124H255.63ZM258.98 118.25H257.08V120.16H258.98C259.61 120.16 260.02 119.78 260.02 119.21C260.02 118.63 259.61 118.25 258.98 118.25ZM262.437 117H263.817L267.297 121.53V117H268.657V124H267.377L263.807 119.32V124H262.437V117ZM269.927 124V117H271.377V122.72H275.207V124H269.927Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.4,
    y: 96.4,
    width: 63.2,
    height: 31.2,
    rx: 3.6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 308,
    y1: 112.7,
    x2: 366,
    y2: 112.7,
    stroke: "#E5E5E5",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308,
    y: 106,
    width: 4,
    height: 6,
    fill: "#0ECA82"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 109,
    width: 4,
    height: 3,
    fill: "#0ECA82"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 99,
    width: 4,
    height: 13,
    fill: "#0ECA82"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 107,
    width: 4,
    height: 5,
    fill: "#0ECA82"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 11,
    transform: "matrix(1 0 0 -1 332 125)",
    fill: "#FA3C58"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 107,
    width: 4,
    height: 5,
    fill: "#0ECA82"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 5,
    transform: "matrix(1 0 0 -1 344 119)",
    fill: "#FA3C58"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 2,
    transform: "matrix(1 0 0 -1 350 116)",
    fill: "#FA3C58"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 106,
    width: 4,
    height: 6,
    fill: "#0ECA82"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362,
    y: 102,
    width: 4,
    height: 10,
    fill: "#0ECA82"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.4,
    y: 96.4,
    width: 63.2,
    height: 31.2,
    rx: 3.6,
    stroke: "#E5E5E5",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.4,
    y: 88.4,
    width: 129.2,
    height: 47.2,
    rx: 7.6,
    stroke: "#E5E5E5",
    strokeWidth: 0.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_bd_1755_30647)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 247,
    y: 160,
    width: 130,
    height: 48,
    rx: 8,
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.63 180V173H259.14C260.52 173 261.49 173.91 261.49 175.2C261.49 176.45 260.5 177.36 259.14 177.36H257.08V180H255.63ZM258.98 174.25H257.08V176.16H258.98C259.61 176.16 260.02 175.78 260.02 175.21C260.02 174.63 259.61 174.25 258.98 174.25ZM262.347 180V174.79H263.717V175.36C264.047 174.91 264.527 174.67 265.107 174.67C265.377 174.68 265.537 174.71 265.677 174.79V175.99C265.477 175.9 265.227 175.85 264.977 175.85C264.447 175.85 263.977 176.12 263.717 176.63V180H262.347ZM265.925 177.4C265.925 175.88 267.145 174.69 268.705 174.69C270.265 174.69 271.485 175.88 271.485 177.4C271.485 178.92 270.265 180.1 268.705 180.1C267.145 180.1 265.925 178.92 265.925 177.4ZM268.705 178.91C269.515 178.91 270.145 178.24 270.145 177.4C270.145 176.54 269.515 175.88 268.705 175.88C267.905 175.88 267.265 176.54 267.265 177.4C267.265 178.24 267.895 178.91 268.705 178.91ZM272.783 178.53V175.94H271.713V174.79H272.783V173.46L274.153 173.15V174.79H275.633V175.94H274.153V178.25C274.153 178.74 274.343 178.92 274.873 178.92C275.133 178.92 275.333 178.89 275.603 178.8V179.92C275.313 180.01 274.843 180.08 274.543 180.08C273.383 180.08 272.783 179.55 272.783 178.53ZM276.023 177.4C276.023 175.88 277.243 174.69 278.803 174.69C280.363 174.69 281.583 175.88 281.583 177.4C281.583 178.92 280.363 180.1 278.803 180.1C277.243 180.1 276.023 178.92 276.023 177.4ZM278.803 178.91C279.613 178.91 280.243 178.24 280.243 177.4C280.243 176.54 279.613 175.88 278.803 175.88C278.003 175.88 277.363 176.54 277.363 177.4C277.363 178.24 277.993 178.91 278.803 178.91ZM285.014 178.9C285.484 178.9 285.884 178.72 286.254 178.32L287.074 179.17C286.534 179.76 285.754 180.1 284.954 180.1C283.414 180.1 282.224 178.92 282.224 177.4C282.224 175.88 283.414 174.69 284.954 174.69C285.784 174.69 286.574 175.03 287.114 175.62L286.274 176.51C285.894 176.09 285.474 175.88 284.984 175.88C284.194 175.88 283.584 176.54 283.584 177.4C283.584 178.26 284.204 178.9 285.014 178.9ZM287.351 177.4C287.351 175.88 288.571 174.69 290.131 174.69C291.691 174.69 292.911 175.88 292.911 177.4C292.911 178.92 291.691 180.1 290.131 180.1C288.571 180.1 287.351 178.92 287.351 177.4ZM290.131 178.91C290.941 178.91 291.571 178.24 291.571 177.4C291.571 176.54 290.941 175.88 290.131 175.88C289.331 175.88 288.691 176.54 288.691 177.4C288.691 178.24 289.321 178.91 290.131 178.91ZM295.123 172.7V180H293.753V173L295.123 172.7ZM255.63 196V189H257.08V196H255.63ZM258.265 196V190.79H259.635V191.2C260.035 190.87 260.525 190.69 261.095 190.69C262.305 190.69 263.155 191.54 263.155 192.76V196H261.785V192.96C261.785 192.3 261.365 191.87 260.705 191.87C260.245 191.87 259.875 192.05 259.635 192.39V196H258.265ZM266.742 194.9C267.212 194.9 267.612 194.72 267.982 194.32L268.802 195.17C268.262 195.76 267.482 196.1 266.682 196.1C265.142 196.1 263.952 194.92 263.952 193.4C263.952 191.88 265.142 190.69 266.682 190.69C267.512 190.69 268.302 191.03 268.842 191.62L268.002 192.51C267.622 192.09 267.202 191.88 266.712 191.88C265.922 191.88 265.312 192.54 265.312 193.4C265.312 194.26 265.932 194.9 266.742 194.9ZM269.079 193.4C269.079 191.88 270.299 190.69 271.859 190.69C273.419 190.69 274.639 191.88 274.639 193.4C274.639 194.92 273.419 196.1 271.859 196.1C270.299 196.1 269.079 194.92 269.079 193.4ZM271.859 194.91C272.669 194.91 273.299 194.24 273.299 193.4C273.299 192.54 272.669 191.88 271.859 191.88C271.059 191.88 270.419 192.54 270.419 193.4C270.419 194.24 271.049 194.91 271.859 194.91ZM275.481 196V190.79H276.851V191.18C277.221 190.86 277.681 190.69 278.211 190.69C278.881 190.69 279.431 190.98 279.781 191.47C280.201 190.96 280.791 190.69 281.501 190.69C282.671 190.69 283.491 191.54 283.491 192.76V196H282.121V192.96C282.121 192.3 281.741 191.87 281.141 191.87C280.721 191.87 280.381 192.05 280.141 192.39C280.161 192.51 280.171 192.63 280.171 192.76V196H278.801V192.96C278.801 192.3 278.421 191.87 277.821 191.87C277.411 191.87 277.091 192.03 276.851 192.34V196H275.481ZM289.214 195.35C288.574 195.87 287.934 196.1 287.104 196.1C285.524 196.1 284.304 194.92 284.304 193.4C284.304 191.89 285.474 190.7 286.984 190.7C288.464 190.7 289.564 191.9 289.564 193.5V193.86H285.684C285.874 194.51 286.444 194.95 287.164 194.95C287.624 194.95 288.034 194.8 288.314 194.53L289.214 195.35ZM286.954 191.83C286.324 191.83 285.844 192.24 285.674 192.88H288.224C288.054 192.26 287.554 191.83 286.954 191.83Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.4,
    y: 168.4,
    width: 63.2,
    height: 31.2,
    rx: 3.6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308,
    y: 193,
    width: 4,
    height: 4,
    fill: "#0ECA82",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 195,
    width: 4,
    height: 2,
    fill: "#0ECA82",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 181,
    width: 4,
    height: 16,
    fill: "#0ECA82",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 191,
    width: 4,
    height: 6,
    fill: "#0ECA82",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 10,
    transform: "matrix(1 0 0 -1 332 197)",
    fill: "#0ECA82",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 194,
    width: 4,
    height: 3,
    fill: "#0ECA82",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 9,
    transform: "matrix(1 0 0 -1 344 197)",
    fill: "#0ECA82",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 3,
    transform: "matrix(1 0 0 -1 350 197)",
    fill: "#0ECA82",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 190,
    width: 4,
    height: 7,
    fill: "#0ECA82",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362,
    y: 185,
    width: 4,
    height: 12,
    fill: "#0ECA82",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 193L317.136 191.044C317.328 190.991 317.501 190.882 317.631 190.731L323.103 184.355C323.278 184.151 323.527 184.027 323.794 184.008L329.082 183.646C329.239 183.635 329.392 183.587 329.527 183.507L334.633 180.453C334.724 180.398 334.824 180.359 334.927 180.335L340.22 179.148L347.051 177.142C347.121 177.121 347.192 177.109 347.265 177.104L352.939 176.715C353.046 176.707 353.152 176.683 353.251 176.642L357.98 174.698C358.03 174.677 358.078 174.652 358.124 174.624L364 171",
    stroke: "#0ECA82",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.4,
    y: 168.4,
    width: 63.2,
    height: 31.2,
    rx: 3.6,
    stroke: "#E5E5E5",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.4,
    y: 160.4,
    width: 129.2,
    height: 47.2,
    rx: 7.6,
    stroke: "#E5E5E5",
    strokeWidth: 0.8
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1755_30647)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 42,
    width: 219,
    height: 141,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1755_30647)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.5,
    cy: 41.5,
    rx: 100.5,
    ry: 54.5,
    fill: "#0DC880",
    fillOpacity: 0.25
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24 78C30.6274 78 36 72.6274 36 66C36 59.3726 30.6274 54 24 54C17.3726 54 12 59.3726 12 66C12 72.6274 17.3726 78 24 78Z",
    fill: "#007AF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8699 59.3554C29.7521 60.4442 31.0788 62.2771 31.5356 64.3528L31.5342 64.3466C31.8156 65.5793 30.8416 66.7804 29.5771 66.8144L29.5386 66.8151L29.5333 66.8151L25.4242 66.8216L27.4772 70.3971L27.49 70.4189C28.1378 71.5493 27.5603 72.9683 26.3267 73.3705L26.2888 73.3825L26.2753 73.3866L26.2617 73.3903C24.1663 73.9528 21.9785 73.7139 20.13 72.6447C18.2478 71.5559 16.9212 69.723 16.4643 67.6473L16.4657 67.6535C16.1844 66.4208 17.1583 65.2197 18.4229 65.1857L18.4613 65.185L18.4667 65.185L22.5757 65.1785L20.5227 61.603L20.51 61.5812C19.8621 60.4508 20.4397 59.0318 21.6732 58.6296L21.7112 58.6176L21.7247 58.6135L21.7383 58.6098C23.8336 58.0473 26.0214 58.2862 27.8699 59.3554ZM23.3093 66.816L23.2998 66.816L23.2936 66.8161L23.2874 66.8161L18.473 66.8237L18.4622 66.824C18.2183 66.8339 18.02 67.0746 18.058 67.2779L18.0602 67.2882L18.0616 67.2944C18.4201 68.9235 19.4658 70.3682 20.9478 71.2255C22.4086 72.0705 24.15 72.2606 25.8383 71.8074L25.8221 71.8116L25.8242 71.811C26.0812 71.7246 26.1925 71.4521 26.0731 71.2377L26.067 71.227L26.0632 71.2207L26.0595 71.2143L23.6569 67.0299L23.6538 67.0245L23.6508 67.019C23.5784 66.8884 23.4573 66.8165 23.3093 66.816ZM22.1616 60.1927L22.1779 60.1885L22.1757 60.1891C21.9187 60.2755 21.8075 60.548 21.9268 60.7624L21.933 60.7731L21.9368 60.7794L21.9405 60.7858L24.343 64.9702L24.3461 64.9756L24.3491 64.9811C24.4215 65.1117 24.5426 65.1836 24.6906 65.1841L24.7001 65.1841L24.7063 65.184L24.7126 65.184L29.5269 65.1764L29.5378 65.1761C29.7816 65.1662 29.9799 64.9255 29.9419 64.7222L29.9398 64.7119L29.9384 64.7057C29.5798 63.0766 28.5342 61.6319 27.0521 60.7746C25.5913 59.9296 23.8499 59.7395 22.1616 60.1927Z",
    fill: "url(#paint1_radial_1755_30647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6073 65.1833H19.3926V66.8164H28.6073V65.1833Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.936 72L44.544 60.8H47.232L51.776 72H49.264L48.128 69.056H43.504L42.352 72H39.936ZM44.224 67.2H47.424L45.84 63.072L44.224 67.2ZM52.7268 72V60.8H55.0468V69.952H61.1748V72H52.7268ZM62.7736 72V60.8H68.3896C70.5976 60.8 72.1496 62.256 72.1496 64.32C72.1496 66.32 70.5656 67.776 68.3896 67.776H65.0936V72H62.7736ZM68.1336 62.8H65.0936V65.856H68.1336C69.1416 65.856 69.7976 65.248 69.7976 64.336C69.7976 63.408 69.1416 62.8 68.1336 62.8ZM74.739 75.344L81.507 60.8H83.715L76.947 75.344H74.739ZM98.002 67.152C98.002 70.208 96.05 72.16 93.042 72.16C90.018 72.16 88.082 70.224 88.082 67.152V60.8H90.402V67.152C90.402 68.896 91.442 70.016 93.058 70.016C94.658 70.016 95.682 68.896 95.682 67.152V60.8H98.002V67.152ZM98.8918 70.224L100.22 68.56C101.532 69.696 102.668 70.192 104.012 70.192C105.404 70.192 106.3 69.648 106.3 68.784C106.3 68.016 105.788 67.632 104.46 67.408L102.236 67.024C100.316 66.704 99.3078 65.664 99.3078 64.032C99.3078 61.936 101.004 60.64 103.724 60.64C105.356 60.64 107.1 61.232 108.348 62.208L107.1 63.936C105.9 63.024 104.78 62.592 103.564 62.592C102.316 62.592 101.516 63.088 101.516 63.856C101.516 64.544 101.964 64.896 103.116 65.072L105.228 65.424C107.468 65.792 108.572 66.848 108.572 68.576C108.572 70.768 106.732 72.16 103.852 72.16C102.044 72.16 100.236 71.456 98.8918 70.224ZM109.961 72V60.8H114.265C117.609 60.8 120.185 63.248 120.185 66.432C120.185 69.568 117.609 72 114.265 72H109.961ZM114.249 62.864H112.281V69.936H114.249C116.233 69.936 117.785 68.4 117.785 66.432C117.785 64.416 116.233 62.864 114.249 62.864Z",
    fill: "black",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.128 103.2V101.696C18.56 101.568 17.152 100.96 16.096 99.968L17.232 98.416C18.048 99.2 19.072 99.712 20.128 99.888V97.296L19.248 97.12C17.168 96.736 16.336 95.92 16.336 94.24C16.336 92.32 17.776 91.12 20.128 91.04V89.856H21.184V91.088C22.48 91.216 23.792 91.664 24.896 92.352L23.968 94.032C22.976 93.44 22.048 93.088 21.184 92.928V95.472L22.032 95.616C24.256 96.048 25.2 96.864 25.2 98.448C25.2 100.352 23.68 101.6 21.184 101.712V103.2H20.128ZM20.032 95.328L20.128 95.344V92.848C19.056 92.88 18.368 93.36 18.368 94.064C18.368 94.848 18.704 95.104 20.032 95.328ZM21.248 97.408L21.184 97.392V99.952C22.336 99.872 23.088 99.376 23.088 98.64C23.088 97.888 22.736 97.648 21.248 97.408ZM30.3294 90.8V102H28.1374V93.024L25.9454 93.92V92.016L28.9374 90.8H30.3294Z",
    fill: "#007AF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.05557 148.6H-11C-13.7614 148.6 -16 150.839 -16 153.6V209.965C-16 212.726 -13.7614 214.965 -11 214.965H214C216.761 214.965 219 212.726 219 209.965V125.74C219 123.961 218.055 122.316 216.517 121.42L201.273 112.537C198.874 111.139 195.795 111.964 194.416 114.375L179.938 139.683C177.867 143.302 172.537 142.946 170.966 139.084L164.401 122.94C163.146 119.855 159.282 118.836 156.668 120.902L143.486 131.323C142.145 132.383 140.356 132.684 138.742 132.123L127.359 128.161C125.262 127.431 122.934 128.173 121.645 129.981L108.025 149.082C106.051 151.851 101.949 151.884 99.9304 149.148L91.9797 138.373C90.004 135.696 86.0129 135.659 83.9884 138.3L68.6393 158.321C66.8082 160.71 63.2975 160.951 61.1568 158.836L46.6505 144.501C45.398 143.263 43.5868 142.776 41.8822 143.217L21.722 148.44C21.3125 148.546 20.8911 148.6 20.4681 148.6H-3.05557Z",
    fill: "url(#paint2_linear_1755_30647)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16 148.6H14.9349H21.1322C21.5674 148.6 22.0007 148.543 22.4212 148.431L41.8643 143.243C43.5781 142.786 45.4059 143.271 46.6677 144.518L61.1568 158.836C63.2975 160.951 66.8082 160.71 68.6393 158.321L83.9884 138.3C86.0129 135.659 90.004 135.696 91.9797 138.373L99.9304 149.148C101.949 151.884 106.051 151.851 108.025 149.082L121.645 129.981C122.934 128.173 125.262 127.431 127.359 128.161L138.742 132.123C140.356 132.684 142.145 132.383 143.486 131.323L156.668 120.902C159.282 118.836 163.146 119.855 164.401 122.94L170.966 139.084C172.537 142.946 177.867 143.302 179.938 139.683L194.416 114.375C195.795 111.964 198.874 111.139 201.273 112.537L219 122.867",
    stroke: "#007AF0"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1755_30647)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 149.5,
    r: 4.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 149.5,
    r: 3.5,
    stroke: "#007AF0",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("line", {
    x1: 12.5,
    y1: 146,
    x2: 12.5,
    y2: 90,
    stroke: "url(#paint3_linear_1755_30647)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1755_30647)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 110.5,
    r: 4.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.5,
    cy: 110.5,
    r: 3.5,
    stroke: "#0ECA82",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("line", {
    x1: 198.5,
    y1: 108,
    x2: 198.5,
    y2: 60,
    stroke: "url(#paint4_linear_1755_30647)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 57,
    width: 49,
    height: 18,
    rx: 6,
    fill: "#0ECA82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.297 62.6962C166.686 62.3106 167.314 62.3106 167.703 62.6962L171.334 66.2893C171.969 66.9177 171.524 68 170.63 68H163.37C162.476 68 162.031 66.9177 162.666 66.2893L166.297 62.6962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.893 66.004L179.097 61.6H184.509V62.98H180.429L180.345 64.936C180.849 64.756 181.353 64.684 181.917 64.684C183.753 64.684 184.989 65.716 184.989 67.264C184.989 68.968 183.609 70.132 181.569 70.132C180.369 70.132 179.277 69.736 178.437 69.004L179.433 67.888C180.165 68.5 180.789 68.74 181.617 68.74C182.637 68.74 183.309 68.188 183.309 67.348C183.309 66.544 182.565 65.992 181.509 65.992C181.005 65.992 180.453 66.112 179.961 66.328L178.893 66.004ZM186.725 68.164C187.265 68.164 187.709 68.608 187.709 69.148C187.709 69.676 187.265 70.12 186.725 70.12C186.197 70.12 185.753 69.676 185.753 69.148C185.753 68.608 186.197 68.164 186.725 68.164ZM190.841 61.6V70H189.197V63.268L187.553 63.94V62.512L189.797 61.6H190.841ZM193.668 65.86C192.504 65.86 191.748 64.996 191.748 63.688C191.748 62.404 192.516 61.528 193.668 61.528C194.808 61.528 195.576 62.404 195.576 63.688C195.576 64.996 194.82 65.86 193.668 65.86ZM193.668 64.984C194.244 64.984 194.592 64.492 194.592 63.688C194.592 62.908 194.232 62.404 193.668 62.404C193.092 62.404 192.744 62.908 192.732 63.688C192.744 64.492 193.08 64.984 193.668 64.984ZM194.424 70H193.2L197.952 61.6H199.188L194.424 70ZM198.828 70.06C197.664 70.06 196.908 69.196 196.908 67.888C196.908 66.604 197.676 65.728 198.828 65.728C199.968 65.728 200.736 66.604 200.736 67.888C200.736 69.196 199.98 70.06 198.828 70.06ZM198.828 69.184C199.404 69.184 199.752 68.692 199.752 67.888C199.752 67.108 199.392 66.604 198.828 66.604C198.252 66.604 197.904 67.108 197.892 67.888C197.904 68.692 198.24 69.184 198.828 69.184Z",
    fill: "white"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 42.4,
    width: 218.2,
    height: 140.2,
    rx: 15.6,
    stroke: "#E5E5E5",
    strokeWidth: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd_1755_30647",
    x: 227,
    y: 0,
    width: 170,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1755_30647"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1755_30647",
    result: "effect2_dropShadow_1755_30647"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1755_30647",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_bd_1755_30647",
    x: 227,
    y: 72,
    width: 170,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1755_30647"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1755_30647",
    result: "effect2_dropShadow_1755_30647"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1755_30647",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_bd_1755_30647",
    x: 227,
    y: 144,
    width: 170,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1755_30647"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur_1755_30647",
    result: "effect2_dropShadow_1755_30647"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1755_30647",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1755_30647",
    x: 66,
    y: -63,
    width: 301,
    height: 209,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25,
    result: "effect1_foregroundBlur_1755_30647"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1755_30647",
    x: 4,
    y: 142,
    width: 17,
    height: 17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1755_30647"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1755_30647",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1755_30647",
    x: 190,
    y: 103,
    width: 17,
    height: 17,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1755_30647"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1755_30647",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1755_30647",
    x1: 340.15,
    y1: 7.67742,
    x2: 340.15,
    y2: 79.6129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ECA82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.557292,
    stopColor: "#1DCE8A",
    stopOpacity: 0.19
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ECA82",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1755_30647",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24 66) rotate(180) scale(4.22553 4.16938)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767676"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1755_30647",
    x1: 110.113,
    y1: 67.3368,
    x2: 110.113,
    y2: 218.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626634,
    stopColor: "#007AF0",
    stopOpacity: 0.15
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1755_30647",
    x1: 12.5,
    y1: 145.364,
    x2: 12.5,
    y2: 90,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007AF0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1755_30647",
    x1: 198.5,
    y1: 107.455,
    x2: 198.5,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ECA82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ECA82",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1755_30647"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 24,
    width: 64,
    height: 32,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1755_30647"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 42,
    width: 219,
    height: 141,
    rx: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.e3f381d9577207600e6a28fb5eb936b9.svg";
export { ForwardRef as ReactComponent };